import Quill from 'quill';
import { QUILL_FONT_PICKER, registerQuillFontWhitelist } from '../../utils/quillFonts';

// Shared with the textbox editor and speaker notes so the three never fight
// over Quill's global attributor registration.
export const SMART_ART_FONT_FAMILIES = QUILL_FONT_PICKER;
export const SMART_ART_FONT_SIZES = ['10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '34px', '36px', '38px', false, '44px', '46px', '48px', '50px', '52px', '54px', '56px', '58px', '60px', '62px', '64px', '72px', '96px'];

// Inline formats plus alignment. Node display renders through deltaToInlineHtml's
// whitelist, so block formats (lists, headers, indent) are not offered. Alignment
// is the one block format included: it maps cleanly to text-align with no box-model
// impact. 'left' is listed explicitly so it is stored as a real value (see below).
export const SMART_ART_TOOLBAR_CONFIG = [
  ['bold', 'italic', 'underline', 'strike'],
  [{ size: SMART_ART_FONT_SIZES }],
  [{ color: [] }, { background: [] }],
  [{ font: SMART_ART_FONT_FAMILIES }],
  [{ align: ['left', 'center', 'right', 'justify'] }],
  ['clean'],
];

let registered = false;
export const registerSmartArtQuillFormats = () => {
  if (registered) return;
  registered = true;
  registerQuillFontWhitelist(Quill);
  const Size = Quill.import('attributors/style/size');
  Size.whitelist = SMART_ART_FONT_SIZES;
  Quill.register(Size, true);
  // Style-based align with 'left' whitelisted so choosing left stores align:'left'
  // instead of removing the attribute (which would fall back to the centered default).
  const Align = Quill.import('attributors/style/align');
  Align.whitelist = ['left', 'center', 'right', 'justify'];
  Quill.register(Align, true);
  // Quill ships align icons for '', center, right, justify but not 'left'; without
  // this the 'left' picker item renders the literal text "undefined". Reuse the
  // default (empty = left-align) icon for the explicit 'left' value.
  const icons = Quill.import('ui/icons');
  if (icons && icons.align && !icons.align.left) icons.align.left = icons.align[''];
};
